<template><div><h1>VUX V2.2.1Rc.8 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[enhance] 修改 prop:format 会触发重新渲染</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] 修复 label 宽度</li>
</ul>
<h2><a href="/zh-CN/components/scroller.html">Scroller</a></h2>
<ul><li>[change] prop:prevent-default 默认设为 false</li>
</ul>
<h2><a href="/zh-CN/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] 当 `fillable` 为true时，修复数字第一位无法编辑的问题</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.8 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.8-225.vue?2a5fbb57